import { TextCSSStyle, TextCSSStyleImpl } from '../textcss';
import { Fonts } from '../../../../utils/resources/fonts';
import { Colors } from '../../../../utils/resources/colors';
export interface MsisdnTextCSSStyle extends TextCSSStyle
{
    getCountryCodeCSSStyle(): object;
    getMSISDNTextCSSStyle(language:any):object;
    getErrorTextDivCSSStyle(): object ;
}

export class MsisdnTextCSSStyleImpl extends TextCSSStyleImpl implements MsisdnTextCSSStyle
{
    getWrapperCSSStyle(): object 
    {
        return {
            display: "flex",
            position: "relative",
            flexDirection: "column",
            marginTop: "0px",
            width:'100%'
        };
    }
    getCountryCodeCSSStyle(): object {
        return {
         fontSize: this.getResources().getFont(Fonts.h7),
         color: this.getResources().getColor(Colors.color_4),
         height: "40px",
         position: "absolute",
         textDecoration: "none",
         border: 0,
         marginTop: "0px",
         marginLeft: "15px", 
         marginRight: "5px",
         fontWeight: 500,
         letterSpacing: 0,
         lineHeight: "40px",
         outline: "none"
        };
     }

    
    getTextCSSStyle(isFloatingLabel: boolean, isDisabled:boolean): object 
    {
       
            return {
                fontSize: this.getResources().getFont(Fonts.h7),
                backgroundColor:isDisabled? this.getResources().getColor(Colors.color_17):this.getResources().getColor(Colors.color_5),
                color: this.getResources().getColor(Colors.color_4),
                height: "40px",
                // bottom: "3px",
                boxSizing: "border-box",
                textDecoration: "none",
                fontWeight: 500,
                letterSpacing: 0,
                lineHeight: "40px",
                width:'100%',
                border:'1px solid'+this.getResources().getColor(Colors.color_8),
                outline: "none",
                paddingLeft: "50px",
                paddingRight: "10px"
            };
    }
    getErrorCSSStyle(): object {
        return {
            fontSize: this.getResources().getFont(Fonts.h7),
            color: this.getResources().getColor(Colors.color_4),
            height: "40px",
            // bottom: "3px",
            width:'100%',
            textDecoration: "none",
            fontWeight: 500,
            letterSpacing: 0,
            lineHeight: "40px",
            border:'1px solid '+this.getResources().getColor(Colors.color_8),
            outline: "none",
            paddingLeft: "50px",
            paddingRight: "10px",
            backgroundColor: this.getResources().getColor(Colors.color_5),
            boxSizing: "border-box",
            // borderLeft: "2px solid " + this.getResources().getColor(Colors.color_12),
        };

        
    }

    getErrorTextDivCSSStyle(): object 
    {
        return {
            width:"50%",
           display: "flex",
        
        };
    }
    getMSISDNTextCSSStyle(language:any): object {
        return {
            color: this.getResources().getColor(Colors.color_7),
            // fontSize: this.getResources().getFont(Fonts.h5),
            margin:'3px 0px 0px auto',
            height:'auto',
            fontFamily:this.getResources().getFontFamily()

        };
    } 
}



// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/text/msisdntext/msisdntextcss.tsx